import { useNavigate } from 'react-router-dom';

import { format } from 'date-fns';
import styled, { css, keyframes } from 'styled-components';
import { ICreatorContentDB } from 'type/db';

import CoreTag from 'shared/tag/CoreTag';
import { ReportSectionCard } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

type Props = {
	creatorPk: number;
	content: ICreatorContentDB;
};
const ChannelContentCard = ({ content, creatorPk }: Props) => {
	const navigate = useNavigate();
	return (
		<ContentCardWrapper
			onClick={() => {
				const pk = creatorPk;
				navigate(`/creator/ig/${pk}/${content.groupId}`);
			}}
		>
			<Grid flex="between" align_items="center" _margin="0 0 8px 0">
				<Text typo="span">
					{format(new Date(content?.missionDate ?? '0'), 'yyyy-MM-dd')}
				</Text>
				<CoreTag
					tag_type="text"
					color_type={'green'}
					value={`${content?.missionNumber}차 미션`}
				/>
				<CoreTag tag_type="text" color_type="black" value={`${content.groupId}기`} />
			</Grid>

			<PostBox>
				<PostImg picture={content?.contentImage} />
			</PostBox>

			<Grid _height="128px" flex="between" direction="column">
				<EllipsisText typo="p_bold" _margin="4px 0">
					{content?.description ?? '-'}
				</EllipsisText>
				<Grid flex="start" direction="column">
					<Grid flex="between">
						<Text typo="span">조회 수</Text>
						<Text typo="span">{content?.viewCount?.toLocaleString() ?? '-'}회</Text>
					</Grid>

					<Grid flex="between">
						<Text typo="span">좋아요 수</Text>
						<Text typo="span">{content?.likeCount?.toLocaleString() ?? '-'}개</Text>
					</Grid>

					<Grid flex="between">
						<Text typo="span">댓글 수</Text>
						<Text typo="span">{content?.commentCount?.toLocaleString() ?? '-'}개</Text>
					</Grid>

					<Grid flex="between">
						<Text typo="span">클릭 수</Text>
						<Text typo="span">{content?.clickCount?.toLocaleString() ?? '-'}개</Text>
					</Grid>
					<Grid flex="between">
						<Text typo="span">저장 수</Text>
						<Text typo="span">{content?.saveCount?.toLocaleString() ?? '-'}개</Text>
					</Grid>
					<Grid flex="between">
						<Text typo="span">공유 수</Text>
						<Text typo="span">{content?.shareCount?.toLocaleString() ?? '-'}개</Text>
					</Grid>
				</Grid>
			</Grid>
		</ContentCardWrapper>
	);
};

const { Grid, Text } = style;

const post_ani = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

const PostBox = styled.div<{ animation?: boolean; delay?: string }>`
	width: 200px;
	height: 200px;
	flex-shrink: 0;
	border-radius: 8px;
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	overflow: hidden;
	position: relative;
	${({ animation }) =>
		animation &&
		css`
			animation: ${post_ani} 2s infinite ease-in-out;
		`}
	${({ delay }) => delay && `animation-delay: ${delay}`};
`;

const PostImg = styled.div<{ picture?: string; color?: string }>`
	position: relative;
	padding-top: 100%;
	overflow: hidden;
	background-color: '#f8f8f8';
	background: url(${({ picture }) => picture}) no-repeat center / cover,
		url('/image/small_no_image.png') no-repeat center / cover;
`;

const EllipsisText = styled(Text)`
	width: 200px;
	${({ theme }) => theme.common.ellipsis_multi(1)};
`;

const ContentCardWrapper = styled(ReportSectionCard)`
	cursor: pointer;
	width: 258px;
	height: 384px;

	transition: 0.2s;

	border: 1px solid transparent;
	background-color: ${({ theme }) => theme.colors.uplus.bg10_lighten};
`;

export default ChannelContentCard;
